module.exports = __webpack_public_path__ + "static/media/1005638.ae178b6d.jpg";